import type { SVGProps } from '@/types/common.types';

const StartSecondarySVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="16"
      viewBox="0 0 32 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_11728_21840)">
        <mask id="mask0_11728_21840" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="16">
          <path d="M0 0H31.8712V16H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_11728_21840)">
          <path
            d="M2.91122 0C0.924878 0 0 1.156 0 2.956V5.044C0 6.912 0.327805 7.708 1.63902 8.552L2.65366 9.2C3.47317 9.708 3.57854 10.084 3.57854 11.176V13.016C3.57854 13.556 3.34049 13.884 2.8878 13.884C2.43512 13.884 2.19317 13.576 2.19317 13.02V10.128H0V13.04C0 14.86 0.905366 16 2.86829 16C4.89366 16 5.81854 14.8 5.81854 13.044V10.776C5.81854 9.044 5.38927 8.152 4.14049 7.336L3.12195 6.664C2.4078 6.196 2.2361 5.864 2.2361 4.664V2.976C2.2361 2.44 2.47415 2.108 2.90341 2.108C3.3561 2.108 3.61756 2.444 3.61756 2.976V5.84H5.81463V2.96C5.81854 1.176 4.89366 0 2.91122 0ZM6.51317 2.444H8.06634V15.78H10.3063V2.44H11.8595V0.22H6.51317V2.444ZM26.5249 0.22V2.444H28.078V15.78H30.318V2.44H31.8712V0.22H26.5249ZM13.2371 0.22L11.9883 15.776H14.2049L14.5132 11.616H16.1405L16.4449 15.776H18.7122L17.4634 0.22H13.2371ZM14.6693 9.508L15.2 2.332H15.4654L15.9922 9.508H14.6732H14.6693ZM25.7054 14.6V10.552C25.7054 9.264 25.2293 8.552 24.0859 8.308V8.04C25.2254 7.86 25.8107 6.996 25.8107 5.596V2.956C25.8107 1.244 24.8195 0.22 22.8995 0.22H19.8556V15.776H22.0995V9.268H23.4576V14.6C23.4576 15.484 23.8244 15.776 23.8244 15.776H26.0644C26.0722 15.776 25.7054 15.492 25.7054 14.6ZM23.5707 5.708C23.5707 6.824 23.3327 7.152 22.5951 7.152H22.1034V2.336H22.6849C23.3756 2.336 23.5707 2.624 23.5707 3.776V5.708Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11728_21840">
          <rect width="32" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StartSecondarySVG;
